export enum NewPasswordRequiredTypeKeys {
  RESET_FIELDS = 'NEW_PASSWORD_REQUIRED_RESET_FIELDS',
  SET_PASSWORD = 'NEW_PASSWORD_REQUIRED_SET_PASSWORD',
  SET_USER = 'NEW_PASSWORD_REQUIRED_SET_USER',
  SAVE_PASSWORD = 'NEW_PASSWORD_REQUIRED_SAVE_PASSWORD'
}

export interface IResetNewPasswordRequiredAction {
  type: typeof NewPasswordRequiredTypeKeys.RESET_FIELDS
  [extraProps: string]: unknown
}

export interface ISetNewPasswordRequiredPasswordAction {
  type: typeof NewPasswordRequiredTypeKeys.SET_PASSWORD
  payload: string
  [extraProps: string]: unknown
}

export interface ISetNewPasswordRequiredUserAction {
  type: typeof NewPasswordRequiredTypeKeys.SET_USER
  payload: any
  [extraProps: string]: unknown
}

export interface ISetNewPasswordRequiredSavePasswordAction {
  type: typeof NewPasswordRequiredTypeKeys.SAVE_PASSWORD
  [extraProps: string]: unknown
}

export type NewPasswordRequiredActionTypes =
  | IResetNewPasswordRequiredAction
  | ISetNewPasswordRequiredPasswordAction
  | ISetNewPasswordRequiredUserAction
  | ISetNewPasswordRequiredSavePasswordAction
